export default "__VITE_ASSET__a9Zo8vcp__"